import { createTypedHooks } from 'easy-peasy'
import { StoreModel } from 'models'

const hooks = createTypedHooks<StoreModel>()

export const useStoreActions = hooks.useStoreActions
export const useStoreDispatch = hooks.useStoreDispatch
export const useStoreState = hooks.useStoreState
